import styled from "styled-components";
import { colors, transition } from "oolib";

const { greyColor100 } = colors;

export const StyledPlaceholderWrapper = styled.div`
  background-color: ${({ theme, dragOverActive }) =>
    dragOverActive
      ? theme?.colors?.primaryColor40
      : theme?.colors?.primaryColor10};
  padding: ${({ smallPlaceholderUI }) => !smallPlaceholderUI && "1.2rem"};
  width: 100%;
  height: 100%;
  ${transition("background-color")}
`;

export const StyledPlaceholder = styled.div`
  display: flex;
  flex-flow: column nowrap;
  height: 100%;
  width: 100%;
  /* gap: ${({ smallPlaceholderUI }) => !smallPlaceholderUI && `0.5rem`}; */
  gap: 0.5rem;
  align-items: center;
  justify-content: center;
  text-align: center;
  border-radius: ${({ containerShape }) =>
    containerShape === "circle" ? "50%" : "unset"};
  border: 0.12rem dashed ${greyColor100};
  padding: ${({ smallPlaceholderUI }) => !smallPlaceholderUI && `2rem`};
  cursor: pointer;
`;

export const SstyledPlaceholder = styled.div`
  display: flex;
  flex-flow: column nowrap;
  height: 100%;
  width: 100%;
  gap: 0.3rem;
  align-items: center;
  justify-content: center;
  text-align: center;
  border-radius: ${({ containerShape }) =>
    containerShape === "circle" ? "50%" : "unset"};
  border: 0.12rem dashed ${greyColor100};
  padding: 2rem;
  cursor: pointer;
`;

export const StyledCautionMsg = styled.div`

border: 1px solid ${colors.yellow} ;
display: flex;
gap: 1rem;
background-color: ${colors.lightYellow} ;
padding: 1rem 2rem;
margin-top: 3rem;
width: fit-content;
max-width: 70%;
`
